import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import { Link } from 'react-router';
import AppModel from '../DataModel/AppModel';

import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';

import PageLoading from '../components/PageLoading';
import right_corner_style from '../utils/right-corner-style';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Add from 'material-ui/svg-icons/content/add';

import Avatar from 'material-ui/Avatar';
import Person from 'material-ui/svg-icons/social/person';
import {green500} from 'material-ui/styles/colors';

import { clearUIMessage } from '../utils/UIMessageBoxes.js';

export default
@observer class UserAdminPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  gotoNewUserPage(id_customer) {
    return function() {
      this.context.router.push('/user_admin/new_user/'+id_customer);
      clearUIMessage();
    }
  }

  // Create a function that links to the right user-detail page
  // for each user-element.
  gotoUserDetailPage(id_customer,id_user) {
    return function() {
      console.log("Going edit user page for ",id_customer,id_user);
      this.context.router.push('/user_admin/edit_user/'+id_customer+'/'+id_user);
      clearUIMessage();
    }
  }

  userList() {
    return (
      <List><Subheader>{uiMsg('UA_USERS_IN_AREA',"Users in your area")}</Subheader>
        {AppModel.userList.map((user) => {
          return (
            <ListItem
              leftAvatar={ <Avatar icon={<Person />}
                                   backgroundColor={green500} />}
              key={user.id_customer+user.id}
              onTouchTap={
                this.gotoUserDetailPage(user.id_customer,user.id).bind(this)
              }
              primaryText={(<div>{user.name}, (<b>{user.id}</b>)</div>)}
              secondaryText={user.email} />
          )
        })}
      </List>
    )
  }

  //<PageLoading loading={AppModel.fetchingJobList}>
  // </PageLoading>

  render() {
    var current_customer = AppModel.id_customer;
    if(AppModel.id_admin_customer!=null && AppModel.canAdminCustomers) {
      current_customer = AppModel.id_admin_customer;
    }
    return (
        <PageLoading loading = {AppModel.fetchingUserList || AppModel.restoringDeletion }>
          {this.userList() }
          <FloatingActionButton
            style={right_corner_style}
            children={<Add />}
            onTouchTap={this.gotoNewUserPage(current_customer).bind(this)} />
        </PageLoading>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/UserAdminPage.jsx
 **/